export enum LabelEnumType {
  Available = 0,
  MoveOut = 1,
  MoveIn = 2,
  Occupied = 3,
  Eviction = 4,
}
